import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=561611da&scoped=true&"
import script from "./CustomPagination.vue?vue&type=script&lang=js&"
export * from "./CustomPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561611da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561611da')) {
      api.createRecord('561611da', component.options)
    } else {
      api.reload('561611da', component.options)
    }
    module.hot.accept("./CustomPagination.vue?vue&type=template&id=561611da&scoped=true&", function () {
      api.rerender('561611da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/partials/CustomPagination.vue"
export default component.exports